import { render, staticRenderFns } from "./ChatStatusChart.vue?vue&type=template&id=71ecb50e"
import script from "./ChatStatusChart.vue?vue&type=script&lang=js"
export * from "./ChatStatusChart.vue?vue&type=script&lang=js"
import style0 from "./ChatStatusChart.vue?vue&type=style&index=0&id=71ecb50e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports